import { render, staticRenderFns } from "./header-bitda.vue?vue&type=template&id=4502446c&"
import script from "./header-bitda.vue?vue&type=script&lang=js&"
export * from "./header-bitda.vue?vue&type=script&lang=js&"
import style0 from "./header-bitda.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./header-bitda.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports